import { render } from "./syntheseExcel.vue?vue&type=template&id=226a3fd4&scoped=true"
import script from "./syntheseExcel.vue?vue&type=script&lang=js"
export * from "./syntheseExcel.vue?vue&type=script&lang=js"

import "./syntheseExcel.vue?vue&type=style&index=0&id=226a3fd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226a3fd4"]])

export default __exports__